module.exports = __webpack_public_path__ + "img/logo-rossignol.3ac308e7.png";